export default "__VITE_ASSET__BgAq1jMt__"